<template>
  <div class="carousel-button">
    <button aria-label="Prev Slider" data-carousel-button-prev :data-carousel-button="name">
      <svg viewBox="0 0 40 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.285645 6.31627C0.102745 6.49452 0 6.73626 0 6.98832C0 7.24038 0.102745 7.48211 0.285645 7.66037L6.49446 13.7098C6.58446 13.8006 6.69211 13.873 6.81113 13.9228C6.93016 13.9726 7.05819 13.9989 7.18773 14C7.31727 14.0011 7.44574 13.977 7.56564 13.9292C7.68554 13.8814 7.79447 13.8108 7.88607 13.7216C7.97767 13.6323 8.05012 13.5262 8.09917 13.4094C8.14823 13.2926 8.17291 13.1674 8.17178 13.0412C8.17066 12.915 8.14374 12.7902 8.09261 12.6742C8.04148 12.5583 7.96716 12.4534 7.87398 12.3657L2.35493 6.98832L7.87398 1.61094C8.05169 1.43166 8.15003 1.19155 8.14781 0.94231C8.14558 0.693074 8.04298 0.454659 7.86209 0.278416C7.68121 0.102172 7.43651 0.00220204 7.18071 3.62396e-05C6.9249 -0.00212956 6.67846 0.0936831 6.49446 0.266837L0.285645 6.31627ZM40 6H2.35493V8H40V6Z"
          fill="currentColor"
        ></path>
      </svg>
    </button>
    <button aria-label="Next Slider" data-carousel-button-next :data-carousel-button="name">
      <svg viewBox="0 0 40 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M39.7144 7.68374C39.8973 7.50548 40 7.26374 40 7.01168C40 6.75962 39.8973 6.51789 39.7144 6.33963L33.5055 0.290198C33.4155 0.199409 33.3079 0.126992 33.1889 0.0771738C33.0698 0.0273554 32.9418 0.0011327 32.8123 3.5892e-05C32.6827 -0.00106091 32.5543 0.0229901 32.4344 0.0707856C32.3145 0.118581 32.2055 0.189164 32.1139 0.278415C32.0223 0.367667 31.9499 0.4738 31.9008 0.590622C31.8518 0.707443 31.8271 0.832614 31.8282 0.95883C31.8293 1.08505 31.8563 1.20978 31.9074 1.32575C31.9585 1.44173 32.0328 1.54662 32.126 1.6343L37.6451 7.01168L32.126 12.3891C31.9483 12.5683 31.85 12.8085 31.8522 13.0577C31.8544 13.3069 31.957 13.5453 32.1379 13.7216C32.3188 13.8978 32.5635 13.9978 32.8193 14C33.0751 14.0021 33.3215 13.9063 33.5055 13.7332L39.7144 7.68374ZM0 7.99999L37.6451 8V6L3.49691e-07 5.99999L0 7.99999Z"
          fill="currentColor"
        ></path>
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    name: string
  }>()
</script>

<style lang="scss" scoped>
  .carousel-button {
    @apply flex items-center gap-6;

    button {
      @apply flex items-center p-0 outline-none border-none bg-transparent px-2 -mx-2 py-3 -my-3;
      color: #555555;

      svg {
        @apply w-10 h-auto;
      }

      &.disabled {
        @apply opacity-50 cursor-not-allowed;
      }
    }

    @include media("xl") {
      @apply gap-5;
    }
    @include media("lg") {
      @apply gap-3;

      button {
        svg {
          @apply w-8;
        }
      }
    }
    @include media("sm") {
      @apply w-full justify-between p-0 px-0.5 m-0 mt-1 pb-2;

      button {
        svg {
          @apply w-7;
        }
      }
    }
  }
</style>
